import React from 'react';
import SessionItem from './SessionItem';

const SessionList = ({
  sessions,
  currentSessionId,
  onSessionClick,
  onSessionDelete,
  onSessionRename
}) => {
  return (
    <div className="sessions-list">
      {sessions.map(session => (
        <SessionItem
          key={session.id}
          session={session}
          isActive={session.id === currentSessionId}
          onSessionClick={onSessionClick}
          onSessionDelete={onSessionDelete}
          onSessionRename={onSessionRename}
          canDelete={sessions.length > 1}
        />
      ))}
    </div>
  );
};

export default SessionList; 